import React from 'react'
import {
  Button,
  TableRow,
  TableCell,
  Table,
  TableBody,
  withStyles
} from '@material-ui/core'
import { useForm, Form, Field } from '../../form'
import { adminValidate } from '../../containers/validate'

const styles = (theme) => ({
  textField: {
    fontSize: '15px',
    marginTop: theme.spacing(4),
    width: '100%'
  },
  tableCell: {
    border: 'none'
  }
})

class AdminExpenseForm extends React.Component {
  render() {
    return <AdminExpenseFormComponent {...this.props} />
  }
}

export default withStyles(styles)(AdminExpenseForm)

const defaultValues = {
  start_date: new Date(),
  end_date: new Date()
}

const AdminExpenseFormComponent = ({ classes, getAdminExpenseReport }) => {
  const form = useForm({
    name: 'adminExpenses',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: adminValidate,
    resetOnSubmit: false
  })

  const { control } = form

  function onSubmit(values) {
    getAdminExpenseReport(values)
  }

  return (
    <Form {...form}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Field
                name="start_date"
                inputType="datepicker"
                label="Alkupvm"
                control={control}
                className={classes.textField}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="end_date"
                inputType="datepicker"
                label="Loppupvm"
                control={control}
                textFieldStyle={{ width: '100%' }}
                className={classes.textField}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Button className="pull-right" type="submit" variant="contained">
                Tallenna kuluraportti
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Form>
  )
}
